"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.english = exports.japanese = void 0;
exports.japanese = [
    // A
    "Abe",
    "Andō",
    "Aoki",
    "Arai",
    // C
    "Chiba",
    // E
    "Endō",
    // F
    "Fujihara",
    "Fujii",
    "Fujita",
    "Fujiwara",
    "Fukuda",
    // G
    "Gotō",
    // H
    "Hara",
    "Harada",
    "Hasegawa",
    "Hashimoto",
    "Hayashi",
    "Hirano",
    // I
    "Ichikawa",
    "Ikeda",
    "Imai",
    "Inou",
    "Ishida",
    "Ishii",
    "Ishikawa",
    "Itō",
    "Iwasaki",
    // K
    "Kaneko",
    "Katō",
    "Kawano",
    "Kikuchi",
    "Kimura",
    "Kinoshita",
    "Kobayashi",
    "Kojima",
    "Kondō",
    "Kōno",
    "Koyama",
    "Kudō",
    // M
    "Maeda",
    "Maruyama",
    "Masuda",
    "Matsuda",
    "Matsui",
    "Matsumoto",
    "Miura",
    "Miyamoto",
    "Miyasaki",
    "Miyazaki",
    "Mori",
    "Morita",
    "Murakami",
    "Murata",
    // N
    "Nakagawa",
    "Nakajima",
    "Nakamura",
    "Nakano",
    "Nakashima",
    "Nakayama",
    "Nishimura",
    "Noguchi",
    "Nomura",
    // O
    "Ogawa",
    "Okada",
    "Okamoto",
    "Ono",
    "Ōno",
    "Ōta",
    "Ōtsuka",
    "Oyama",
    // S
    "Satō",
    "Saitō",
    "Sakai",
    "Sakamoto",
    "Sakurai",
    "Sano",
    "Sasaki",
    "Shibata",
    "Shimada",
    "Shimizu",
    "Sugahara",
    "Sugawara",
    "Sugiyama",
    "Suzuki",
    // T
    "Takada",
    "Takagi",
    "Takahashi",
    "Takaki",
    "Takata",
    "Takeda",
    "Taketa",
    "Takeuchi",
    "Tamura",
    "Tanaka",
    "Taniguchi",
    // U
    "Uchida",
    "Ueda",
    "Ueno",
    "Ueta",
    // W
    "Wada",
    "Watabe",
    "Watanabe",
    "Watanabe",
    // Y
    "Yamada",
    "Yamaguchi",
    "Yamamoto",
    "Yamashita",
    "Yamazaki",
    "Yokoyama",
    "Yoshida",
];
exports.english = [
    // A
    "Alexander",
    "Anderson",
    // B
    "Brown",
    // C
    "Campbell",
    "Clark",
    "Clarke",
    "Cox",
    // D
    "Davies",
    "Davis",
    "Doherty",
    "Driscoll",
    // E
    "Edwards",
    "Evans",
    // G
    "Graham",
    "Green",
    "Griffiths",
    // H
    "Hall",
    "Hamilton",
    "Hughes",
    // J
    "Jackson",
    "James",
    "Jenkins",
    "Johnson",
    "Johnston",
    "Jones",
    // K
    "Kelly",
    "Khan",
    // L
    "Lewis",
    // M
    "MacDonald",
    "Martin",
    "Mason",
    "McLaughlin",
    "Mitchell",
    "Moore",
    "Morgan",
    "Morrison",
    "Moss",
    "Murphy",
    "Murray",
    // O
    "O’Neill",
    "Owen",
    // P
    "Patel",
    "Paterson",
    "Phillips",
    "Price",
    // Q
    "Quinn",
    // R
    "Rees",
    "Reid",
    "Roberts",
    "Robertson",
    "Robinson",
    "Rodríguez",
    "Ross",
    // S
    "Scott",
    "Smith",
    "Smyth",
    "Stewart",
    // T
    "Taylor",
    "Thomas",
    "Thompson",
    "Thomson",
    // W
    "Walker",
    "Watson",
    "White",
    "William",
    "Williams",
    "Wilson",
    "Wood",
    "Wright",
    // Y
    "Young",
];
